import script from "./KeepItUpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KeepItUpPage.vue?vue&type=script&setup=true&lang=js"

import "./KeepItUpPage.vue?vue&type=style&index=0&id=2b46a96f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b46a96f"]])

export default __exports__